import styled from 'styled-components';
import { breakpoints } from '../../constants';

export const Row = styled.div`
    @media (${breakpoints.mediumMin}) {
        display: flex;
    }
`;
